import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { router } from '@/app/router';
import { trackPageView } from '@/shared/lib/analytics';
import { resolveThemeForFavicon, syncFavicon } from '@/shared/lib/favicon';
import { installMockFetch, isMockEnabled } from '@/mocks';
import '@/shared/styles/index.css';

syncFavicon(resolveThemeForFavicon());

// Navegações SPA — o page_view inicial já sai do snippet gtag no index.html.
let lastTrackedPath = window.location.pathname + window.location.search;
router.subscribe(({ location }) => {
  const path = location.pathname + location.search;
  if (path === lastTrackedPath) return;
  lastTrackedPath = path;
  trackPageView(path);
});

// Modo mock (VITE_USE_MOCKS=true): intercepta o BFF antes de qualquer requisição.
if (isMockEnabled()) installMockFetch();

const container = document.getElementById('root');
if (!container) throw new Error('Elemento #root não encontrado');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
